import React, { useContext, useEffect, useState } from 'react';
import '../MasterDataContainer.sass';
import IconButton from '../../../components/_controls/IconButton/IconButton';
import { MiscContext } from '../../../context/misc.context';
import Enums from '../../../enums';
import EditableTable from '../../../components/_tables/EditableTable/EditableTable';
import * as Presenter from './Diagnosis.presenter';
import { useHistory } from 'react-router';
import GlobalHttpErrorHandler from '../../../errors/globalHttpErrorHandler';
import { faPlus, faSearch, faSpinner } from '@fortawesome/free-solid-svg-icons';
import MasterDataService from '../../../services/masterData.service';
import DiagnosisService from '../../../services/history.service copy';
import Configs from '../../../config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Diagnosis = () => {

    // <> Context
    const { setMasterDataOpenedPopup, setMasterDataOpenedPopupState, addAlert, setOpenPopup, setOpenPopupState } = useContext(MiscContext);

    // <> History
    const history = useHistory();

    // <> States
    const [isLoading, setIsLoading] = useState(false);
    const [diagnosis, setDiagnosis] = useState([]);
    const [query, setQuery] = useState('');

    // <> Actions
    

    // <> Effects
    useEffect(() => {
        if(!query) return;

        const searchDebounce = setTimeout(getData, Configs.misc.searchDelay);

        return () => clearTimeout(searchDebounce);
        
    }, [query]);

    // <> Actions
    function onAddClicked() {
        setMasterDataOpenedPopup(Enums.AddMasterDataPopupTags.Diagnosis);
    }

    async function getData() {

        try {

            // -> Turn Loader ON
            setIsLoading(true);

            // -> Get Master Data From API
            const diagnosisResponse = await DiagnosisService.search({ query, limit: 10 });;
            const diagnosisRes = diagnosisResponse.data.data.diagnosis;
    
            // -> Format the data
            const presentableData = Presenter.presentData(diagnosisRes);
    
            // -> Set Allergies
            setDiagnosis(presentableData);
        }
        catch(e) {
            GlobalHttpErrorHandler(e, history, addAlert);
        }
        finally {
            setIsLoading(false);
        }
    }

    async function updateField(rowId, fieldName, newValue) {

        try {

            // -> Turn Loader ON
            setIsLoading(true);

            // -> Update Col in API
            await MasterDataService.updateCol(Enums.MasterData.Diagnosis, rowId, fieldName, newValue);

            // -> Refetch Data
            getData();

        }
        catch(e) {
            GlobalHttpErrorHandler(e, history, addAlert);
            setIsLoading(false);
        }
    }

    async function deleteRow(rowId) {

        // -> Confirm
        setOpenPopupState({
            level: 'danger',
            message: 'Are you sure you want to delete this diagnosis?',
            onOk: async () => {

                try {
        
                    // -> Turn Loader ON
                    setIsLoading(true);
        
                    // -> Update Col in API
                    await MasterDataService.deleteRow(Enums.MasterData.Diagnosis, rowId);
        
                    // -> Refetch Data
                    getData();
                }
                catch(e) {
                    GlobalHttpErrorHandler(e, history, addAlert);
                    setIsLoading(false);
                }
                
            }
        })
        setOpenPopup(Enums.PopupTags.Confirmation);
        
    }

    // <> JSX
    return (
        <div className="master-data">

            <div className="master-data__top">

                {/* Title */}
                <div className="master-data__top__title">Diagnosis</div>

                <div className="master-data__top__actions">
                    {/* Add Allergy Button */}
                    <div className="master-data__top__actions__action">
                        <IconButton 
                            text={'Add'}
                            icon={faPlus}
                            onClickFn={onAddClicked} />
                    </div>
                </div>
            </div>

            <div className="master-data__container">

                {/* Search */}
                <div className="master-data__search">
                    <div className="master-data__search-input">
                        <div className="master-data__search-input__icon">
                            {!isLoading && <FontAwesomeIcon icon={faSearch} />}
                            {isLoading && <div className="spinner"><FontAwesomeIcon icon={faSpinner} /></div>}
                        </div>
                        <input 
                            className="master-data__search-input__control"
                            placeholder="Search"
                            onChange={ev => setQuery(ev.target.value)} />
                    </div>
                </div>

                <EditableTable
                    isLoading={isLoading}
                    items={diagnosis}
                    updateField={updateField}
                    deleteRow={deleteRow}
                    columnDefinitions={Presenter.tableColumnDefinitions()} />

            </div>
        </div>
    );
};

export default Diagnosis;